// 安卓手机通知权限开启引导
export const AndroidNotice18n = {
  zh: {
    androidNoticeTitle: '开启通知权限',
    androidNoticeH1: '安卓手机通知权限开启引导',
    androidNoticeText1:
      '若您未开启链上会APP系统消息通知权限，或已开启通知权限但没有收到设备消息，请参考以下内容查看权限开启状态。',
    androidNoticeText2:
      '该引导以华为NOVO 10型号 鸿蒙3.0系统为示例，不同版本权限开启路径略有不同，可寻找相应的设置项进行操作。',
    androidNoticeText3: '1.开启消息通知权限',
    androidNoticeText4: '2.开启自启动权限',
    androidNoticeText5: '3.开启悬浮窗/桌面弹窗权限',
    'androidNoticeText5-1': '3.开启悬浮窗权限',
    'androidNoticeStep1-1':
      '第一步:点击顶部"去开启通知权限"按钮，进入链上会【应用信息】(或在手机【设置】-【应用与服务】-【应用管理】中，找到【链上会】进入)',
    'androidNoticeStep1-2':
      '第二步:点击进入【通知管理】 开启【允许通知】【锁屏通知】【横幅通知】【允许打扰】',
    'androidNoticeStep1-3':
      '第三步:开启【服务提醒】中的【允许通知】【锁屏通知】【横幅通知】',
    androidNoticeSubTitle1: '操作步骤如下:',
    'androidNoticeStep2-1':
      '第一步:在链上会【应用信息】中，选择【权限】 进入【链上会权限】',
    'androidNoticeStep2-2':
      '第二步:找到【后台弹窗】【悬浮窗】权限，选择【开启】',
    'androidNoticeStep3-1':
      '第一步:在手机设置中，找到【应用和服务】中，选择【应用启动管理】',
    'androidNoticeStep3-2': '第二步:找到链上会，允许【自启动】和【后台活动】',
    androidNoticeText6:
      '如果以上权限都已确认开启，那么可能是部分手机系统需要打开其他权限；',
    androidNoticeText7: '更多教程，可点击视频查看：',
    androidNotice: {
      openTip1: '开启消息通知权限',
      openTip2: '开启自启动权限',
      openTipStep: '查看操作步骤',
      comfirm1: '我已确认并开启消息通知权限',
      comfirm2: '我已确认并开启自启动权限',
      goOpen: '去开启',
      finish: '完成',
    },
  },
  en: {
    androidNoticeTitle: 'Turn on notification permissions',
    androidNoticeH1:
      'Android mobile phone notification permission opening guide',
    androidNoticeText1:
      'If you have not enabled the APP system message notification permission on the ChainPal, or have enabled the notification permission but have not received device messages, please refer to the following content to check the permission status.',
    androidNoticeText2:
      'This guide takes Huawei NOVO 10 model HMS 3.0 system as an example. Different versions have slightly different permission opening paths, and you can find the corresponding setting items to operate.',
    androidNoticeText3: '1. Turn on the message notification permission',
    androidNoticeText4: '2. Turn on the self-starting permission',
    androidNoticeText5:
      '3. Open the permission of floating window/desktop pop-up window',
    'androidNoticeText5-1': '3. Open the floating window permission',
    'androidNoticeStep1-1':
      'Step 1: Click on the "Open Notification Permission" button at the top to enter the [Application info] on the ChainPal (Or in [Settings] - [Apps & services] - [Apps] on the mobile phone, find [ChainPal] and enter)',
    'androidNoticeStep1-2':
      'Step 2: Click to enter [Notification Management], turn on [Allow Notification] [Lock Screen Notification] [Banner Notification] [Allow Disturbance]',
    'androidNoticeStep1-3':
      'Step 3: Turn on [Allow notifications] [Lock screen ] [Banner ] in [Service notifications]',
    androidNoticeSubTitle1: 'The operation steps are as follows:',
    'androidNoticeStep2-1':
      'Step 1: In the [Application infos] of the ChainPal, select [Permissions] to enter [ChainPal permissions]',
    'androidNoticeStep2-2':
      'Step 2: Find [Background pop-up ] [Dropzone] permission, select [Allow]',
    'androidNoticeStep3-1':
      'Step 1: In the phone settings, find [Apps& services] and select [Launch Manager]',
    'androidNoticeStep3-2':
      'Step 2: Find the ChainPal on the chain and allow [Auto-launch] and [Run in background ]',
    androidNoticeText6:
      'If the above permissions have been confirmed to be enabled, it may be that some mobile phone systems need to open other permissions;',
    androidNoticeText7: 'For more tutorials, click on the video to view:',
    androidNotice: {
      openTip1: 'Turn on the message notification permission',
      openTip2: 'Turn on the self-starting permission',
      openTipStep: 'View steps',
      comfirm1:
        'I have confirmed and enabled the message notification permission',
      comfirm2: 'I have confirmed and enabled the auto-start permission',
      goOpen: 'Open',
      finish: 'Finish',
    },
  },
};
